import React from 'react'

import {classes} from './styles'

type Props = {
  title?: string
}

const List: React.FC<React.PropsWithChildren<Props>> = ({title, children}) => {
  return (
    <div>
      {title && <div className={classes.title}>{title}</div>}
      <div>{children}</div>
    </div>
  )
}

export default List
